import { LOCATION_FETCHED } from "../types";

const initialState = {
  locationData: [] as any,
};
const locations = (state = initialState, action: any) => {
  switch (action.type) {
    case LOCATION_FETCHED:
      return {
        ...state,
        locationData: action.locationData,
        loading: false,
      };

       default:
      return state;
  }
};

export default locations;



